import View from './View.js';
import Data from './Data.js';

export default Data(View);
